import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // Disable console.log and console.debug in production for security
  // Keep console.warn and console.error for Sentry crash reporting
  window.console.log = () => {};
  window.console.debug = () => {};

  Sentry.init({
    dsn: 'https://6cfee3b4ac87d45e542c57ad36580754@o4508709100126208.ingest.de.sentry.io/4508709818990673',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Sentry v8: `tracingOrigins` (browserTracing option) → `tracePropagationTargets` (top-level init)
    tracePropagationTargets: ['localhost', /^https:\/\/zcsazzurrosystemsweb\.com/],
    tracesSampleRate: 1.0,
    release: environment.version,
  });
  Sentry.setTag('app_name', 'Customer Portal');
  Sentry.setTag('app_version', environment.version);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => console.error(err));
